import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { Reveal } from '@/components/landing/Reveal'
import { RagPipelineMockup } from '@/components/landing/VisionMockups'
import { PageOutro, VisionSection } from '@/components/landing/Section'

/** The Knowledge page: answering from your own documents. */
export function KnowledgePage() {
  return (
    <>
      <Knowledge />
      <PageOutro>
        <h2 className="nv-h2 text-[1.6rem] sm:text-[2rem]">Your documents never leave your computer</h2>
        <p className="mx-auto mt-3 max-w-xl text-[15px] leading-relaxed text-brand-body">Indexing your own files is planned. Everything NevTan AI does today already runs locally.</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link to="/download" className="nv-btn-primary-lg">
            Download NevTan AI <ArrowRight size={16} />
          </Link>
          <Link to="/roadmap" className="nv-btn-outline-lg">See what ships today</Link>
        </div>
      </PageOutro>
    </>
  )
}

function Knowledge() {
  return (
    <VisionSection
      id="knowledge"
      eyebrow="Your knowledge"
      title="Ask questions of your own documents"
      lede="Point NevTan AI at a folder of PDFs, notes, or code. It indexes them on your machine, then answers your questions and shows which files it used."
      tone="panel"
      status="planned"
    >
      <Reveal>
        <RagPipelineMockup />
      </Reveal>

      <div className="mt-3 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {[
          ['Chat with PDFs', 'Contracts, manuals, and papers'],
          ['Project documentation', 'Ask instead of searching'],
          ['Your own codebase', 'Answers that cite the file'],
          ['A private knowledge base', 'Indexed and answered locally'],
        ].map(([title, note], index) => (
          <Reveal key={title} delay={index * 70}>
            <div className="h-full rounded-xl border border-brand-line bg-brand-paper p-4 shadow-card">
              <h3 className="text-[13.5px] font-bold text-brand-heading">{title}</h3>
              <p className="mt-1 text-[12.5px] leading-relaxed text-brand-muted">{note}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </VisionSection>
  )
}

